import { Grid } from '@mui/material';
import styled from 'styled-components';
import { useManagePlanQuery } from '../../hooks/useManagePlanQuery';
import { PlanPill } from '../../PlanPill';
import { PlanCalendarEventProps } from '../PlanCalendarEventMapper';

const EventModalContainer = styled(Grid)`
  & * {
    cursor: pointer;
  }
`;

interface EventModalProps {
  calendarEvent: PlanCalendarEventProps;
}

export const EventModal = ({ calendarEvent }: EventModalProps) => {
  const { navigateToPlan } = useManagePlanQuery();
  return (
    <EventModalContainer onClick={() => navigateToPlan({ planId: calendarEvent.plan.id })}>
      <PlanPill plan={calendarEvent.plan} style={{ padding: `10px` }} />
    </EventModalContainer>
  );
};
